function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "u5iseegspa",
  width: "256.2%",
  height: "256.2%",
  x: "-78.1%",
  y: "-71.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "2j1zl7thvb",
  cx: 16,
  cy: 16,
  r: 16
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-263 -48) translate(263 48)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#u5iseegspa)",
  xlinkHref: "#2j1zl7thvb"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#2j1zl7thvb"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#001854"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.565 16.439c0-.236-.182-.46-.513-.666-.942-.587-1.524-1.61-1.524-2.72v-2.59c0-2.48-1.722-4.559-4.036-5.105.006-.046.008-.093.008-.14C13.5 4.545 12.955 4 12.283 4c-.673 0-1.218.545-1.218 1.218 0 .047.003.094.008.14-2.314.546-4.036 2.624-4.036 5.105v2.59c0 1.11-.582 2.133-1.524 2.72-.331.206-.513.43-.513.666 0 .828 2.255 1.525 5.327 1.737.07 1.019.919 1.824 1.956 1.824 1.036 0 1.885-.805 1.955-1.824 3.072-.212 5.327-.91 5.327-1.737",
  transform: "translate(-263 -48) translate(263 48) translate(4 4)"
})))));

var SvgIconBell = function SvgIconBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bell.d0457e61.svg";
export { ForwardRef as ReactComponent };